import React from 'react';
import { Media } from '@honda-canada/design-system-react';
import FiltersListDesktop from './shared/FiltersListDesktop';
import FiltersListMobile from './shared/FiltersListMobile';
import FilterSection from './shared/FiltersSection';
import FiltersSectionItem from './shared/FiltersSectionItem';
import InventoryFiltersSectionItem from './shared/InventoryFiltersSectionItem';
const VehicleListFiltersUI = ({ filterOptionsList, componentName, isInventoryVariant }) => {
    const renderedFilterOptionsList = filterOptionsList === null || filterOptionsList === void 0 ? void 0 : filterOptionsList.map(filterOption => (React.createElement(FilterSection, { key: filterOption.key, filterOption: filterOption, ItemComponent: isInventoryVariant ? InventoryFiltersSectionItem : FiltersSectionItem })));
    return (React.createElement("div", { "data-gtm-component-type": componentName },
        React.createElement(Media, { greaterThanOrEqual: "desktop" },
            React.createElement(FiltersListDesktop, { filterOptionsList: renderedFilterOptionsList })),
        React.createElement(Media, { lessThan: "desktop" },
            React.createElement(FiltersListMobile, { filterOptionsList: renderedFilterOptionsList }))));
};
export default VehicleListFiltersUI;
